import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { LoadingBarState } from '@ngx-loading-bar/core/loading-bar.state';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as UserAccountsActions from '../actions/user-accounts.action';
import { ClientManagementService } from '../../../management/services';
import { UserAccount } from '../../../management/models';


@Injectable()
export class UserAccountsEffects {
    public getCurrentClientUserAccounts$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserAccountsActions.getCurrentClientUserAccounts),
            switchMap(() => {
                this.loader.start();
                return this.clientManagementService.getClientUsers().pipe(
                    map((data: UserAccount[]) =>
                        UserAccountsActions.getCurrentClientUserAccountsSuccess({data})
                    ),
                    catchError((error: any) =>
                        of(UserAccountsActions.getCurrentClientUserAccountsFailure({ error }))
                    ),
                    finalize(() => {
                        this.loader.complete();
                    })
                );
            })
        )
    );


  private loader!: LoadingBarState;

  constructor(
    private actions$: Actions,
    private loadingBar: LoadingBarService,
    private clientManagementService: ClientManagementService
  ) {
    this.loader = this.loadingBar.useRef('main');
  }
}
